import styled, { css } from 'styled-components/macro';
import TableTabs from '../../../components/TableTabs';
import { DefaultIcon } from '../../../components/Icon';
// import {
//   tableSpacingMobile,
//   tableSpacingDesktop,
//   tableSpacingLgDesktop
// } from '../CrudTableStyles';
import { SpacerTd } from '../../../components/ModelListStyles';
import {
  marginTableMobile,
  marginTableDefault,
  defaultSpacing
} from '../../../styles/utils';

export const SummaryHeaderDiv = styled.div``;

export const TransactionDetailsDiv = styled.div`
  display: flex;
  flex-direction: column;
  @media screen and (min-width: 768px) {
    flex-direction: row;
  }
  > h5 {
    @media screen and (min-width: 768px) {
      font-size: 1.5rem;
    }
    @media screen and (min-width: 1024px) {
      font-size: 1.6rem;
    }
  }
  ${defaultSpacing};
`;

export const SummaryHeaderH5 = styled.h5`
  color: ${props => props.color};
  @media screen and (max-width: 767px) {
    margin-top: 5px;
  }
  @media screen and (min-width: 768px) {
    margin-left: 5px;
  }
`;

export const SummaryHeaderP = styled.p`
  margin-bottom: 2.3rem;
  margin-top: 1.3rem;
  @media screen and (min-width: 768px) {
    margin-bottom: 2.8rem;
    margin-top: 0.8rem;
  }
  @media screen and (min-width: 1440px) {
    margin-top: 1rem;
  }
  ${defaultSpacing};
`;

export const SummaryDiv = styled.div`
  border: 1px solid ${props => props.theme.mercury};
  background-color: ${props => props.theme.concrete};
  padding-left: 27px;
  padding-right: 27px;
  padding-top: 35px;

  @media screen and (min-width: 1024px) {
    padding-left: 40px;
    padding-right: 40px;
  }
  ${defaultSpacing};
`;

export const SummaryRowDiv = styled.div`
  /* padding-bottom: 15px; */
  padding-bottom: 10px;
  display: flex;
  flex-direction: column;
  @media screen and (min-width: 768px) {
    flex-direction: row;
  }
  @media screen and (min-width: 1024px) {
    padding-bottom: 8px;
  }
`;

export const SummaryColumnDiv = styled.div``;

export const SummaryDataDiv = styled.div`
  display: flex;
  flex-direction: column;
  ${props =>
    !props.hasFooter &&
    css`
      margin-bottom: 25px;
    `}

  @media screen and (min-width: 1024px) {
    flex-direction: row;
    > div:not(:first-child) {
      padding-left: 30px;
    }
  }
  ${props =>
    !props.hasHorizontalRule &&
    css`
      margin-bottom: 20px;
    `}
`;

export const SummaryP = styled.p`
  font-size: 1.2rem;
  ${props => props.theme.fontStackBody};
  font-weight: 300;
  ${props =>
    props.bold &&
    css`
      ${props.theme.fontStackHeader};
      font-weight: 500;
      width: 145px;
    `}
  @media screen and (min-width: 1024px) {
    min-width: 110px;
    ${props =>
      props.first &&
      css`
        width: 145px;
      `}
    font-size: 1.3rem;
  }
`;

export const HorizontalRule = styled.div`
  border-bottom: 2px solid #ffffff;
  margin-bottom: 15px;
  margin-top: 5px;
  @media screen and (min-width: 768px) {
    margin-top: 20px;
  }
  @media screen and (min-width: 1024px) {
    margin-bottom: 24px;
  }
`;

export const ToggleTabs = styled(TableTabs)`
  margin-top: 23px;
  margin-bottom: 15px;
  ${defaultSpacing};
`;

export const CustomPerPageFilterDiv = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;

  margin-left: ${marginTableMobile};
  margin-right: ${marginTableMobile};
  @media screen and (min-width: 768px) {
    margin-left: ${marginTableDefault};
    margin-right: ${marginTableDefault};
  }
  @media screen and (max-width: 768px) {
    margin-bottom: 30px;
  }
`;

export const CustomPerPageFilterSmall = styled.small`
  text-transform: uppercase;
  font-weight: 600;
`;

export const CustomPerPageFilterDropdownDiv = styled.div`
  border: 1px solid ${props => props.theme.mercury};
  width: 53px;
  height: 27px;
  /* display: flex;
  justify-content: space-evenly; */
  align-items: center;
  margin-left: 10px;
  > div {
    > ul {
      > li {
        > span {
          color: ${props => props.theme.black};
        }
        > svg {
          fill: ${props => props.theme.black};
        }
      }
    }
  }
`;

export const CustomDefaultIcon = styled(DefaultIcon)`
  width: 8px;
  height: 6px;
`;

export const CustomSpacerTd = styled(SpacerTd)`
  /* @media screen and (max-width: 1023px) {
  }
  @media screen and (min-width: 1024px) {
  }
  @media screen and (min-width: 1440px) {
  } */
`;
